const LICENSE_URL = process.env.API_URL + '/xugarhero/license';

const getUnusedLicenses = (context) => {
  return new Promise((resolve, reject) => {
    context.$http.get(LICENSE_URL)
      .then((response) => {
        resolve(response.body);
      }, error => {
        reject(error);
      });
  });
};

const deleteLicense = (context, id) => {
  return new Promise((resolve, reject) => {
    context.$http.delete(LICENSE_URL, {params: {id: id}})
      .then((response) => {
        resolve(response);
      }, error => {
        reject(error);
      });
  });
};

const createLicenses = (context, order) => {
  return new Promise((resolve, reject) => {
    context.$http.post(LICENSE_URL, order)
      .then((response) => {
        resolve(response);
      }, error => {
        reject(error);
      });
  });
};

export default {
  getUnusedLicenses,
  deleteLicense,
  createLicenses
};



// WEBPACK FOOTER //
// ./src/brand/health/api/license/index.js